import React from "react";
import { useI18n } from "../providers/I18nProvider";
import { useBetSlip } from "../providers/BetSlipProvider";

interface PlaceBetErrorModalProps {
  messageKey: PlaceBetModalErrorKey;
  cultureUrl: string;
  onClose: () => void;
}

const NOT_ENOUGH_FUNDS_TITLE = "BetSlipStakeErrorPopupNoEnoughMoney-popup";

const extractBodyText = (html: string): string =>
  html
    .replace(/<h[1-6][^>]*>.*?<\/h[1-6]>/gi, "")
    .replace(/<button[^>]*>.*?<\/button>/gi, "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const extractTitle = (html: string): string => {
  const match = html.match(/<h[1-6][^>]*>(.*?)<\/h[1-6]>/i);
  return match ? match[1].replace(/<[^>]*>/g, "").trim() : "";
};

const extractButtonText = (html: string, id: string): string => {
  const pattern = new RegExp(
    `<button[^>]*id=['"]${id}['"][^>]*>(.*?)<\\/button>`,
    "i",
  );
  const match = html.match(pattern);
  return match ? match[1].replace(/<[^>]*>/g, "").trim() : "";
};

const extractBodyLines = (html: string): string[] => {
  const pattern = /<h[1-6][^>]*>(.*?)<\/h[1-6]>/gi;
  const lines: string[] = [];
  let match: RegExpExecArray | null;
  while ((match = pattern.exec(html)) !== null) {
    lines.push(match[1].replace(/<[^>]*>/g, "").trim());
  }
  return lines;
};

export const PlaceBetErrorModal: React.FC<PlaceBetErrorModalProps> = ({
  messageKey,
  cultureUrl,
  onClose,
}) => {
  const { t } = useI18n();
  const { onNavigate } = useBetSlip();
  const html = t(messageKey);
  const backButtonText = extractButtonText(html, "back");
  const hasOwnTitle = messageKey !== NOT_ENOUGH_FUNDS_TITLE

  const handleDeposit = () => {
    onNavigate(`${cultureUrl}/user/deposit`);
  };

  return (
    <div className="px-4 pb-3 pt-6 flex flex-col items-center">
      {hasOwnTitle ? (
        <>
          <div className="text-center text-25 font-bold mb-4">
            {extractTitle(html)}
          </div>
          <div className="text-center text-md mb-8">
            {extractBodyText(html)}
          </div>
        </>
      ) : (
        <div className="text-center text-25 mb-8">
          {extractBodyLines(html).map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
      )}
      <div className="w-full space-y-3">
        <button
          onClick={handleDeposit}
          className="w-full h-[45px] text-22 bg-btn-continue-betting text-btn-continue-betting-text rounded-4"
        >
          {extractButtonText(html, "deposit")}
        </button>
        {backButtonText && (
          <button
            onClick={onClose}
            className="w-full h-[45px] text-22 border border-gray-300 rounded-4"
          >
            {backButtonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default PlaceBetErrorModal;
